/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Partners_SubtitleInputs */



/**
* | output |
* | --- |
* | "Manage partners and their portal admins." |
*
* @param {Partner_Admin_Partners_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_partners_subtitle = /** @type {((inputs?: Partner_Admin_Partners_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Partners_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verwalten Sie Partner und deren Portal-Admins.")
	return /** @type {LocalizedString} */ ("Manage partners and their portal admins.")
});